"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reduce;
exports.getNotificationLinkValidation = getNotificationLinkValidation;
exports.getNotificationById = getNotificationById;
exports.getPreviousPageTimestamp = getPreviousPageTimestamp;
exports.getNotificationsById = getNotificationsById;
exports.getNotificationsArray = getNotificationsArray;
exports.getLastClickTimestamp = getLastClickTimestamp;
exports.getNewNotifications = getNewNotifications;
exports.getEarlierNotifications = getEarlierNotifications;
exports.getFilteredNewNotifications = getFilteredNewNotifications;
exports.getFilteredEarlierNotifications = getFilteredEarlierNotifications;
exports.getServerTime = getServerTime;
exports.getServerTimestamp = getServerTimestamp;
exports.getClientTimestamp = getClientTimestamp;
exports.getNotificationFilters = getNotificationFilters;
exports.getLatestNotificationTimestamp = getLatestNotificationTimestamp;
exports.getFilteredNotificationsById = getFilteredNotificationsById;
exports.getFilteredNotifications = getFilteredNotifications;
exports.getFilteredNotificationsOffset = getFilteredNotificationsOffset;
exports.getSearchQueryForNotificationFilters = getSearchQueryForNotificationFilters;
exports.getUnreadNotificationCount = getUnreadNotificationCount;
exports.getLastOpenTimestamp = getLastOpenTimestamp;
exports.getLastCloseTimestamp = getLastCloseTimestamp;
exports.getAccessToken = getAccessToken;
exports.getLocale = getLocale;
exports.getActiveIMSOrg = getActiveIMSOrg;
exports.getEnvironment = getEnvironment;
exports.isFlyoutOpen = isFlyoutOpen;
exports.getActiveTabIndex = getActiveTabIndex;
exports.hasTimelineEndReached = hasTimelineEndReached;
exports.getNotificationAlerts = getNotificationAlerts;
exports.getDisplayAlertsConfig = getDisplayAlertsConfig;
exports.initialState = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var types = _interopRequireWildcard(require("../actions/actionTypes"));

var Constants = _interopRequireWildcard(require("../../constants/Constants"));

var _NotificationMetadataFilters = _interopRequireDefault(require("../../constants/NotificationMetadataFilters"));

var _compact = _interopRequireDefault(require("lodash/compact"));

var _concat = _interopRequireDefault(require("lodash/concat"));

var _findIndex = _interopRequireDefault(require("lodash/findIndex"));

var _forOwn = _interopRequireDefault(require("lodash/forOwn"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _map = _interopRequireDefault(require("lodash/map"));

var _orderBy = _interopRequireDefault(require("lodash/orderBy"));

var _pickBy = _interopRequireDefault(require("lodash/pickBy"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialState = {
  accessToken: '',
  activeIMSOrg: '',
  locale: 'en-US',
  environment: 'dev',
  byId: {},
  //{}
  notifications: [],
  //[ids]
  alerts: [],
  filteredNotifications: [],
  filteredNotificationsOffset: 0,
  filters: {
    metadata: _NotificationMetadataFilters.default,
    categories: []
  },
  filteredNotificationsById: {},
  isFlyoutOpen: false,
  searchQuery: '',
  activeTabIndex: 0,
  isEndOfTimeline: false,
  validLink: true,
  lastClickTimestamp: Date.now(),
  //TODO: Need to document the purpose of each timestamp stored in state.
  lastOpenTimestamp: Date.now(),
  lastCloseTimestamp: Date.now(),
  lastNotificationSeenTimestamp: Date.now(),
  previousPageTimestamp: 123,
  clientTimestamp: 124,
  serverTimestamp: 125,
  displayAlertsConfig: Constants.DEFAULT_DISPLAY_ALERTS
};
exports.initialState = initialState;

function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var payload = action.payload;
  var notificationsById, filteredNotificationsById;

  switch (action.type) {
    case types.NOTIFICATIONS_CONFIG_FETCHED:
      return _objectSpread({}, state, {
        accessToken: payload.accessToken,
        activeIMSOrg: payload.activeIMSOrg,
        locale: payload.locale,
        environment: payload.environment
      });

    case types.ACTIVE_IMS_ORG_CHANGED:
      return _objectSpread({}, state, {
        activeIMSOrg: payload.activeIMSOrg,
        byId: {},
        notifications: [],
        alerts: [],
        activeTabIndex: 0
      });

    case types.NOTIFICATIONS_FETCHED:
      return _objectSpread({}, state, {
        byId: _objectSpread({}, _objectSpread({}, state.byId), {}, _objectSpread({}, payload.notificationsById)),
        notifications: (0, _compact.default)((0, _concat.default)(state.notifications, (0, _map.default)((0, _orderBy.default)(payload.notificationsById, 'sortedTimestamp', 'desc'), 'id'))),
        isEndOfTimeline: state.previousPageTimestamp == payload.previousPageTimestamp,
        previousPageTimestamp: payload.previousPageTimestamp
      });

    case types.LONG_POLL_NOTIFICATIONS_FETCHED:
      var newEntries = (0, _pickBy.default)(action.notificationsById, function (entry) {
        return (0, _findIndex.default)(state.notifications, function (id) {
          return id == entry.id;
        }) < 0;
      });

      if (!(0, _isEmpty.default)(newEntries)) {
        var newNotifAsArray = (0, _map.default)((0, _orderBy.default)(newEntries, 'sortedTimestamp', 'desc'), 'id');
        var newAlerts = (0, _toConsumableArray2.default)(state.alerts);

        if (!state.isFlyoutOpen) {
          //Alerts should show up if the flyout is not open and the priority of the notifications is high
          var filteredNotifs;

          switch (state.displayAlertsConfig.type) {
            case 'NONE':
              filteredNotifs = [];
              break;

            case 'ALL':
              filteredNotifs = newNotifAsArray;
              break;

            default:
              filteredNotifs = newNotifAsArray.filter(function (entry) {
                return newEntries[entry].priority.toLowerCase() == Constants.HIGH;
              });
              break;
          }

          newAlerts = [].concat((0, _toConsumableArray2.default)(state.alerts.slice(0)), (0, _toConsumableArray2.default)(filteredNotifs));
        }

        return _objectSpread({}, state, {
          byId: _objectSpread({}, _objectSpread({}, state.byId), {}, _objectSpread({}, newEntries)),
          notifications: (0, _compact.default)((0, _concat.default)(newNotifAsArray, state.notifications)),
          alerts: newAlerts
        });
      }

      return state;

    case types.NOTIFICATIONS_UPDATED:
      return _objectSpread({}, state, {
        byId: _objectSpread({}, _objectSpread({}, state.byId), {}, _objectSpread({}, action.notificationsById)),
        filteredNotificationsById: _objectSpread({}, _objectSpread({}, state.filteredNotificationsById), {}, _objectSpread({}, action.notificationsById))
      });

    case types.LATEST_SERVER_TIMESTAMP_FETCHED:
      return _objectSpread({}, state, {
        serverTimestamp: action.serverTimestamp,
        clientTimestamp: Date.now()
      });

    case types.MARK_NOTIFICATIONS_AS_SHOWN:
      return _objectSpread({}, state, {
        alerts: state.alerts.filter(function (item) {
          var found = false;

          for (var i = 0; i < action.ids.length; ++i) {
            if (item == action.ids[i]) {
              found = true;
              break;
            }
          }

          return !found;
        })
      });

    case types.SET_REMINDER_ON_NOTIFICATION:
      notificationsById = state.byId;

      if (state.byId && state.byId[payload.id]) {
        notificationsById = _objectSpread({}, state.byId, (0, _defineProperty2.default)({}, payload.id, _objectSpread({}, state.byId[payload.id], {
          reminderTime: payload.reminderTime
        })));
      }

      filteredNotificationsById = state.filteredNotificationsById;

      if (state.filteredNotificationsById[payload.id]) {
        filteredNotificationsById = _objectSpread({}, state.filteredNotificationsById, (0, _defineProperty2.default)({}, payload.id, _objectSpread({}, state.filteredNotificationsById[payload.id], {
          reminderTime: payload.reminderTime
        })));
      }

      return _objectSpread({}, state, {
        byId: notificationsById,
        filteredNotificationsById: filteredNotificationsById
      });

    case types.REMOVE_REMINDER_ON_NOTIFICATION:
      // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
      // @ts-ignoregit push
      var _state$byId$payload$i = _objectSpread({}, state.byId[payload.id]),
          reminderTime = _state$byId$payload$i.reminderTime,
          noReminderTime = (0, _objectWithoutProperties2.default)(_state$byId$payload$i, ["reminderTime"]);

      filteredNotificationsById = state.filteredNotificationsById;

      if (state.filteredNotificationsById[payload.id]) {
        filteredNotificationsById = _objectSpread({}, state.filteredNotificationsById, (0, _defineProperty2.default)({}, payload.id, noReminderTime));
      }

      return _objectSpread({}, state, {
        byId: _objectSpread({}, state.byId, (0, _defineProperty2.default)({}, payload.id, noReminderTime)),
        filteredNotificationsById: filteredNotificationsById
      });

    case types.SET_LAST_USER_CLICK_TIMESTAMP:
      return _objectSpread({}, state, {
        lastClickTimestamp: payload
      });

    case types.MARK_NOTIFICATION_AS_UNREAD:
      return _objectSpread({}, state, {
        byId: _objectSpread({}, state.byId, (0, _defineProperty2.default)({}, payload.id, _objectSpread({}, state.byId[payload.id], {
          isRead: false
        })))
      });

    case types.MARK_NOTIFICATION_AS_READ:
      return _objectSpread({}, state, {
        byId: _objectSpread({}, state.byId, (0, _defineProperty2.default)({}, payload.id, _objectSpread({}, state.byId[payload.id], {
          isRead: true
        })))
      });

    case types.TOGGLE_NOTIFICATION_READ_STATUS:
      //mark in the main array, mark in the filtered array
      notificationsById = state.byId;

      if (state.byId && state.byId[payload.id]) {
        notificationsById = _objectSpread({}, state.byId, (0, _defineProperty2.default)({}, payload.id, _objectSpread({}, state.byId[payload.id], {
          isRead: !state.byId[payload.id].isRead
        })));
      }

      filteredNotificationsById = state.filteredNotificationsById;

      if (state.filteredNotificationsById[payload.id]) {
        filteredNotificationsById = _objectSpread({}, state.filteredNotificationsById, (0, _defineProperty2.default)({}, payload.id, _objectSpread({}, state.filteredNotificationsById[payload.id], {
          isRead: !state.filteredNotificationsById[payload.id].isRead
        })));
      }

      return _objectSpread({}, state, {
        byId: notificationsById,
        filteredNotificationsById: filteredNotificationsById
      });

    case types.FILTERED_NOTIFICATIONS_FETCHED:
      return _objectSpread({}, state, {
        filteredNotificationsById: _objectSpread({}, _objectSpread({}, state.filteredNotificationsById), {}, _objectSpread({}, payload.notificationsById)),
        filteredNotifications: (0, _toConsumableArray2.default)((0, _map.default)((0, _orderBy.default)(payload.notificationsById, 'sortedTimestamp', 'desc'), 'id')),
        filteredNotificationsOffset: payload.offset,
        searchQuery: payload.searchQuery
      });

    case types.PAGINATED_FILTEREDNOTIFICATION_FETCHED:
      return _objectSpread({}, state, {
        filteredNotificationsById: _objectSpread({}, _objectSpread({}, state.filteredNotificationsById), {}, _objectSpread({}, payload.notificationsById)),
        filteredNotifications: [].concat((0, _toConsumableArray2.default)(state.filteredNotifications), (0, _toConsumableArray2.default)((0, _map.default)((0, _orderBy.default)(payload.notificationsById, 'sortedTimestamp', 'desc'), 'id'))),
        filteredNotificationsOffset: payload.offset
      });

    case types.NOTIFICATION_FILTERS_FETCHED:
      return _objectSpread({}, state, {
        filters: _objectSpread({}, _objectSpread({}, state.filters), {
          categories: payload
        })
      });

    case types.MARK_ALL_NOTIFICATION_AS_READ:
      //create a new copy, update the notification status to read and replace the state
      var copy = _objectSpread({}, state.byId);

      var newCopy = {};
      (0, _forOwn.default)(copy, function (value, key) {
        value.isRead = true;
        newCopy[key] = value;
      }); //also update the filtered store

      var filteredCopy = _objectSpread({}, state.filteredNotificationsById);

      var filteredNewCopy = {};
      (0, _forOwn.default)(filteredCopy, function (value, key) {
        value.isRead = true;
        filteredNewCopy[key] = value;
      });
      return _objectSpread({}, state, {
        byId: newCopy,
        filteredNotificationsById: filteredNewCopy
      });

    case types.SET_FLYOUT_LAST_OPEN_TIMESTAMP:
      return _objectSpread({}, state, {
        lastOpenTimestamp: payload,
        isFlyoutOpen: true
      });

    case types.SET_FLYOUT_LAST_CLOSE_TIMESTAMP:
      return _objectSpread({}, state, {
        lastCloseTimestamp: payload,
        isFlyoutOpen: false
      });

    case types.ACTIVE_TAB_INDEX_CHANGED:
      return _objectSpread({}, state, {
        activeTabIndex: payload
      });

    case types.DISPLAY_ALERTS_FETCHED:
      return _objectSpread({}, state, {
        displayAlertsConfig: payload
      });

    case types.NOTIFICATION_URL_LINK_VALIDATION:
      return _objectSpread({}, state, {
        validLink: payload
      });

    case types.SET_LAST_NOTIFICATION_SEEN_TIMESTAMP:
      /*
        * lastNotificationSeenTimestamp is for showing New and Earlier sections
        * as current behaviour is on opening flyout, remove the counter from bell icon
        * in unified-shell but still group the notifications into new and early
        */
      return _objectSpread({}, state, {
        lastNotificationSeenTimestamp: payload
      });

    default:
      return state;
  }
}

function getNotificationLinkValidation(state) {
  return state.notifications.validLink;
}

function getNotificationById(state, id) {
  var notification = state.notifications.byId && state.notifications.byId[id];

  if (!notification) {
    notification = state.notifications.filteredNotificationsById && state.notifications.filteredNotificationsById[id];
  }

  return notification;
}

function getPreviousPageTimestamp(state) {
  return state.notifications.previousPageTimestamp;
}

function getNotificationsById(state) {
  return state.notifications.byId;
}

function getNotificationsArray(state) {
  return state.notifications.notifications;
}

function getLastClickTimestamp(state) {
  return state.notifications.lastClickTimestamp;
}

function getNewNotifications(state) {
  if (state.notifications && state.notifications.notifications) {
    return state.notifications.notifications.filter(function (entry) {
      return state.notifications.byId[entry].sortedTimestamp > state.notifications.lastNotificationSeenTimestamp;
    });
  }

  return [];
}

function getEarlierNotifications(state) {
  return state.notifications.notifications.filter(function (entry) {
    return state.notifications.byId[entry].sortedTimestamp < state.notifications.lastNotificationSeenTimestamp;
  });
}

function getFilteredNewNotifications(state) {
  if (state.notifications.filteredNotifications) {
    return state.notifications.filteredNotifications.filter(function (entry) {
      return state.notifications.filteredNotificationsById[entry].sortedTimestamp > state.notifications.lastNotificationSeenTimestamp;
    });
  }

  return [];
}

function getFilteredEarlierNotifications(state) {
  if (state.notifications.filteredNotifications) {
    return state.notifications.filteredNotifications.filter(function (entry) {
      return state.notifications.filteredNotificationsById[entry].sortedTimestamp < state.notifications.lastNotificationSeenTimestamp;
    });
  }

  return [];
}
/**
 * Should not use Date.now() in it.
 *
 * @param state
 */


function getServerTime(state) {
  var serverTimestamp = state.notifications.serverTimestamp;
  var clientTimestamp = state.notifications.clientTimestamp;
  var timeNow = Date.now();
  return serverTimestamp + timeNow - clientTimestamp;
}

function getServerTimestamp(state) {
  return state.notifications.serverTimestamp;
}

function getClientTimestamp(state) {
  return state.notifications.clientTimestamp;
}

function getNotificationFilters(state) {
  return state.notifications.filters;
}

function getLatestNotificationTimestamp(state) {
  if (state.notifications.notifications.length > 0) {
    return state.notifications.byId[state.notifications.notifications[0]].sortedTimestamp;
  }

  return 0;
}

function getFilteredNotificationsById(state) {
  return state.notifications.filteredNotificationsById;
}

function getFilteredNotifications(state) {
  return state.notifications.filteredNotifications;
}

function getFilteredNotificationsOffset(state) {
  return state.notifications.filteredNotificationsOffset;
}

function getSearchQueryForNotificationFilters(state) {
  return state.notifications.searchQuery;
}

function getUnreadNotificationCount(state) {
  var count = 0;
  (0, _forOwn.default)(state.notifications.byId, function (value) {
    if (!value.isRead) {
      count++;
    }
  });
  return count;
}

function getLastOpenTimestamp(state) {
  return state.notifications.lastOpenTimestamp;
}

function getLastCloseTimestamp(state) {
  return state.notifications.lastCloseTimestamp;
}

function getAccessToken(state) {
  return state.notifications.accessToken;
}

function getLocale(state) {
  return state.notifications.locale;
}

function getActiveIMSOrg(state) {
  return state.notifications.activeIMSOrg;
}

function getEnvironment(state) {
  return state.notifications.environment;
}

function isFlyoutOpen(state) {
  return state.notifications.isFlyoutOpen;
}

function getActiveTabIndex(state) {
  return state.notifications.activeTabIndex;
}

function hasTimelineEndReached(state) {
  return state.notifications.isEndOfTimeline;
}

function getNotificationAlerts(state) {
  return state.notifications.alerts;
}

function getDisplayAlertsConfig(state) {
  return state.notifications.displayAlertsConfig;
}